
<template>
  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" :width="width" :height="height" viewBox="0 0 26 26">
    <defs>
      <clipPath id="clip-path">
        <rect id="Rectangle_1834" data-name="Rectangle 1834" :width="26" :height="26" transform="translate(1329.121 200.363)" :fill="color"/>
      </clipPath>
    </defs>
    <g id="my_stores" data-name="my stores" transform="translate(-1329.121 -200.363)" clip-path="url(#clip-path)">
      <path id="store" d="M7.691,27.065H21.462a3.78,3.78,0,0,0,3.774-3.774v-9.8a3.834,3.834,0,0,0,1.233-1.124,5.109,5.109,0,0,0,.4-4.663l-2.114-5.8a1.248,1.248,0,0,0-1.183-.83h-18a1.248,1.248,0,0,0-1.183.83L2.281,7.7a5.109,5.109,0,0,0,.4,4.663,3.834,3.834,0,0,0,1.233,1.124v9.8A3.78,3.78,0,0,0,7.691,27.065Zm15-23.484,1.812,4.974a2.627,2.627,0,0,1-.1,2.365,1.479,1.479,0,0,1-1.292.6,4.064,4.064,0,0,1-3.581-3.539L19,3.581Zm-10.576,4.7.57-4.7h3.774l.57,4.7a3.135,3.135,0,0,1-.721,2.441,2.29,2.29,0,0,1-3.472,0A3.135,3.135,0,0,1,12.119,8.277Zm-1.166,4.11a4.815,4.815,0,0,0,7.246,0,5.811,5.811,0,0,0,.436-.579,6.168,6.168,0,0,0,4.085,2.206V23.29a1.256,1.256,0,0,1-1.258,1.258H19.575V22.8a5,5,0,1,0-10,0v1.745H7.691A1.256,1.256,0,0,1,6.433,23.29V14.014a6.168,6.168,0,0,0,4.085-2.206A5.8,5.8,0,0,0,10.953,12.387ZM4.646,8.554,6.458,3.581h3.7L9.62,7.975a4.064,4.064,0,0,1-3.581,3.539,1.479,1.479,0,0,1-1.292-.6A2.627,2.627,0,0,1,4.646,8.554Z" transform="translate(1327.547 199.299)" :fill="color"/>
    </g>
  </svg>
</template>
<script>

export default {
  name:'IconMyStores',
  props: {
    color: {
      type: String,
      default: '#4e4e4e',
    },
    width: {
      type: Number,
      default: 26,
    },
    height: {
      type: Number,
      default: 26,
    },
  },
};
</script>